import { useQuery } from '@tanstack/react-query'
import {
  fetchPowerBiEmbedConfig,
  type PowerBiDashboardType,
} from '@/api/powerbi'
import { queryKeys } from '@/lib/queryKeys'

const POWER_BI_STALE_TIME = 45 * 60 * 1000
const POWER_BI_GC_TIME = 60 * 60 * 1000

export function usePowerBiDashboard(
  reportId: string | null,
  reportType: PowerBiDashboardType | null,
  options: { enabled?: boolean } = {}
) {
  const { enabled = true } = options
  return useQuery({
    queryKey: queryKeys.powerBi.dashboard(
      reportType ?? 'unselected',
      reportId ?? 'unselected'
    ),
    queryFn: () =>
      fetchPowerBiEmbedConfig(
        reportId as string,
        reportType as PowerBiDashboardType
      ),
    enabled: enabled && Boolean(reportId && reportType),
    staleTime: POWER_BI_STALE_TIME,
    gcTime: POWER_BI_GC_TIME,
    retry: 1,
  })
}
